// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A multiple-choice quiz widget designed specifically for our 'Traveller' vertical.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Traveller quiz",
  id: "traveller-quiz",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/traveller-quiz/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "TravellerQuizConfigTool" */ "app/components/tools/TravellerQuizConfigTool/TravellerQuizConfigTool"),
    loading: DynamicImportLoader,
    modules: ["TravellerQuizConfigTool"]
  })
};

export default CONFIG;
